import { throwForFailedResponse } from "@/lib/errors/error-handler";

export type AppPlatform = "ios" | "android";

export type AppRatingItem = {
  platform: AppPlatform;
  rating: number;
  review_count: number;
  created_at: string;
  updated_at: string;
};

async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(path, {
    headers: { "Content-Type": "application/json" },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data?.success === false) {
    throwForFailedResponse(res, data, "Request failed");
  }
  return (data?.data ?? data) as T;
}

export const appService = {
  async getAppRating(platform: AppPlatform) {
    return getJson<AppRatingItem>(`/api/public/app-rating?platform=${platform}`);
  },
};
